import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import '../styles/Concursos.css';

/*Componentes Convocatorias*/
import Concurso_FrutiVerdura_2025 from './Concursos/ConcursoFutriVerdura2025';
import Concurso_NutriProducto_2025 from './Concursos/ConcursoNutriProducto2025';
import Concurso_SumaqWaykuy_2025 from './Concursos/ConcursoSumaqWaykuy2025';
import Concurso_Huaylia_Chumbivilcana_2025 from './Concursos/ConcursoHuayliaChumbivilcana2025';

function Concursos(){
  const location = useLocation();
  const [concursoActivo, setConcursoActivo] = useState('CONCURSO FRUTI-VERDURA 2025');
  
  const concursosData = {
    'CONCURSO FRUTI-VERDURA 2025' : Concurso_FrutiVerdura_2025,
    'CONCURSO NUTRI-PRODUCTO 2025' : Concurso_NutriProducto_2025,
    'CONCURSO SUMAQ-WAYKUY 2025' : Concurso_SumaqWaykuy_2025,
    'CONCURSO HUAYLIA CHUMBIVILCANA 2025': Concurso_Huaylia_Chumbivilcana_2025,
  };
  
  useEffect(() => {
    if (location.state?.selected && concursosData[location.state.selected]) {
      setConcursoActivo(location.state.selected);
    }
  }, [location.state]);
  return (
    <div className='concursos-wrapper'>
      <div className='concursos-sidebar'>
        {Object.keys(concursosData).map((concurso) => (
          <button
            key={concurso}
            className={`concursos-btn ${concursoActivo === concurso ? 'activo' : ''}`}
            onClick={() => setConcursoActivo(concurso)}
          >
            {concurso}
          </button>
        ))}
      </div>
      <div className='concursos-content'>
        {concursosData[concursoActivo] && React.createElement(concursosData[concursoActivo])}
      </div>
    </div>
  );
};

export default Concursos;


